import wxRegisterShareEvent from './wxShareConfig';
import HllUI from '@/libs/hll-m-ui';
import storage from '@/libs/storage';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import AES from './aes';
import Vue from 'vue';
import config from '@/config';
import Fingerprint2 from 'fingerprintjs2';
const vm = new Vue();
//工具类
import {
  getUrlParam,
  setStorage,
  getStorage,
  parseQuery,
  parseURL,
  stringifyQuery,
  urlParamHandle,
  getQueryArgs,
  removeStorage,
  scrollToEl,
  overFlowHide,
  overFlowAuto,
  formatTime,
  type,
  randomArr, //打乱数组
  isInIframe,
  calculateTimeDifference,
  sample,
  randomString,
  genAccessTokenStr,
  starPhone
} from './util';
//环境判断
import {
  isWxMiniProgram, //是否是微信小程序
  isWeixinBrowser, //是否是微信浏览器
  isAlipayMiniUa,
  isBaiduBoxUa,
  isLtlMiniProgram,
  isLtlApp,
  isJdMiniProgram,
  isXlMiniProgram,
  isMoveMini,
  isMoveAlpayMini,
  isQuickAppUa,
  isWxMiniProgramNew,
  isCompanyApp,
  isHllApp,
  getUserAppVer,
  isIOS,
  isMobile,
  isAlipayH5,
  isXlAppByClientType
} from './judgeEnv';

//获取坐标位置
import {
  getLocation,
  getWxLocation,
  getAppLocation,
  getAmapLocation
} from './location';
import { XL_ACCOUNT_TYPE, LALAMOVE_ACCOUNT_TYPE } from './constants';

/**
 * 微信分享
 * @param {*} 配置
 */
function wxShare({ title, desc, img, link, success, error }) {
  wxRegisterShareEvent(title, desc, link, img, success, error);
}
/**
 * 节流函数(连续触发时第一次立即触发,之后每 delay ms 执行一次)
 * @param {Function} fn 需要节流的方法
 * @param {Number} delay 单位:ms,每次执行函数的间隔
 */
function throttle(fn, delay = 500) {
  let last = 0; //绑定时时间由Date.now()改为0,第一次点击时不应以该函数执行时作为起点
  return function(...args) {
    if (Date.now() - last > delay) {
      //两次执行间隔大于delay
      last = Date.now(); //执行方法,刷新最后调用时间
      return fn.apply(this, args);
    }
  };
}

/**
 *
 * @param fn {Function}   实际要执行的函数
 * @param delay {Number}  延迟时间，也就是阈值，单位是毫秒（ms）
 *
 * @return {Function}     返回一个“去弹跳”了的函数
 */
function debounce(fn, delay) {
  // 定时器，用来 setTimeout
  var timer;

  // 返回一个函数，这个函数会在一个时间区间结束后的 delay 毫秒时执行 fn 函数
  return function() {
    // 保存函数调用时的上下文和参数，传递给 fn
    var context = this;
    var args = arguments;

    // 每次这个返回的函数被调用，就清除定时器，以保证不执行 fn
    clearTimeout(timer);

    // 当返回的函数被最后一次调用后（也就是用户停止了某个连续的操作），
    // 再过 delay 毫秒就执行 fn
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * 极验初始化
 * @param callback 回调函数
 * @param phoneNo 手机号码
 * @param type 验证码类型
 */
function geetestInit(callback, phoneNo, type) {
  if (typeof window.hasGeetestInit != 'undefined') return;
  if (!type) type = 'bind';
  if (!phoneNo) phoneNo = '';
  vm.$axios
    .post('/act/passport/geetest', {
      phone_no: phoneNo,
      t: new Date().getTime()
    })
    .then(data => {
      window.hasGeetestInit = 1;
      initGeetest(
        {
          gt: data.gt,
          challenge: data.challenge,
          new_captcha: data.new_captcha,
          product: type, // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
          offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
        },
        callback
      );
    });
}
/**
 * 验证手机号码的正确性、非空
 * @param phone
 * @returns {boolean}
 */
function verifyPhone(phone) {
  if (!phone) {
    HllUI.$hll.toast('请输入手机号码');
    return false;
  } else if (!/^1\d{10}$/.test(phone)) {
    HllUI.$hll.toast({
      message: '你输入的手机号码不符合要求', // 多行用\n间隔
      iconClass: 'icon-warning', // 失败icon
      timeout: 1000, // 显示时间
      callback: function() {
        // 消失后的回调
        // console.log("callback");
      }
    });
    return false;
  } else {
    return true;
  }
}

//与app交互
function callApp(json) {
  // if (isIOS()) {
  //   window.webkit.messageHandlers.app.postMessage(json);
  // } else {
  //   app.webcall(json);
  // }
  if (isIOS()) {
    console.log('ios 分享');
    window.webkit.messageHandlers.app.postMessage(json);
  } else {
    try {
      console.log('安卓++++++');
      app.webcall(json);
    } catch (e) {
      console.log(e);
      try {
        window.webkit.messageHandlers.app.postMessage(json);
      } catch (err) {
        console.log(err);
        app.postMessage && app.postMessage(json);
      }
    }
  }
}

/**
 * 需要微信授权的页面可以执行的方法
 * @param referer 授权后的回调地址，不填默认当前页面地址
 */
function needWxAuth(referer) {
  if (!isWeixinBrowser()) return;
  var wxCode = getUrlParam('wx_code') || storage.get('wx_code');
  if (wxCode) {
    vm.$axios
      .get('/act/common/mp/wx_token', {
        params: {
          wx_code: wxCode
        }
      })
      .then(res => {
        if (!res.has) return;
        storage.set('wx_token', res.wx_token);
      })
      .catch(err => {
        vm.$hll.toast(err);
      });
  }
  if (getWxToken()) return;
  //授权失败
  if (getUrlParam('wx_token_fail')) {
    vm.$hll.toast('微信授权失败，请关掉页面重新进入');
    throw new Error();
  }
  if (!wxCode) toWxAuth(referer);
}

// 跳转对应端口下单页
/**
 *
 * @param { param } callback 回调function，常用于神策上报回调
 */
function toOrderPage(callback) {
  let cont = callback && typeof callback == 'function';
  if (cont) callback();
  setTimeout(
    () => {
      if (isHllApp()) {
        //货拉拉app
        useCoupon(1);
      } else if (isWxMiniProgram()) {
        //小程序
        wx.miniProgram.navigateTo({
          url: '/pages/home/index'
        });
      } else {
        location.href = `https://m.huolala.cn`;
      }
    },
    cont ? 1000 : 0
  );
}

//微信授权Promise方案
async function needWxAuthPromise(referer) {
  return new Promise(async resolve => {
    if (!isWeixinBrowser()) {
      return resolve(false);
    }
    var wxCode = getUrlParam('wx_code');
    if (wxCode) {
      try {
        let res = await vm.$axios.get('/act/common/mp/wx_token', {
          params: {
            wx_code: wxCode
          }
        });
        if (!res.has) {
          return resolve(false);
        }
        storage.set('wx_token', res.wx_token);
        return resolve(res.wx_token);
      } catch (err) {
        console.log(err);
        vm.$hll.toast('获取微信通行证失败');
        return;
      }
    }
    let wx_token = getWxToken();
    if (wx_token) {
      return resolve(wx_token);
    }
    //授权失败
    if (getUrlParam('wx_token_fail')) {
      vm.$hll.toast('微信授权失败，请关掉页面重新进入');
      throw new Error();
    }
    if (!wxCode) {
      toWxAuth(referer);
    }
  });
}
/**
 * 跳转去微信授权
 * @param referer
 */
function toWxAuth(referer) {
  if (!isWeixinBrowser()) return;
  if (!referer) referer = location.href;
  location.href = `${config.baseURL}/act/common/mp/auth?referer=${escape(
    referer
  )}`;
  throw new Error();
}
//获取浏览器指纹
function getFingerPrint() {
  let fingerprint = getStorage('deviceCode');
  if (!/^\w{32}$/.test(fingerprint)) {
    fingerprint = '';
  }
  return new Promise(resolve => {
    if (fingerprint) {
      resolve(fingerprint);
    } else {
      Fingerprint2.getPromise({}).then(components => {
        let values = components.map(function(component) {
          return component.value;
        });
        let murmur = Fingerprint2.x64hash128(values.join(''), 31);
        fingerprint = murmur;
        setStorage('deviceCode', murmur);
        resolve(fingerprint);
      });
    }
  });
}
//获取同盾指纹
function getTDPrint() {
  return new Promise(resolve => {
    if (_fmOpt.getinfo) {
      resolve(_fmOpt.getinfo());
    } else {
      resolve('');
    }
  });
}
//获取同盾免登录passcode
function getTDPass() {
  return new Promise(resolve => {
    if (_fmOpt.getTdpassCode) {
      _fmOpt.getTdpassCode(resolve);
    } else {
      resolve('');
    }
  });
}

//获取 access_token,兼容多个账户体系
function getAccessToken(config = {}) {
  return storage.get(genAccessTokenStr(config.accountType));
}
//获取微信Token
function getWxToken() {
  return storage.get(`wx_token`);
}

// 转换 String userType 为 id
function parseUserType(userTypeStr) {
  const userTypeMap = {
    user: 1,
    driver: 2,
    company: 1
  };
  return userTypeMap[userTypeStr];
}

// 转换 String userType 为 id
// 小拉是 `8`,之前的都是 `1`
function parseBusinessLine(accountType) {
  if (accountType === XL_ACCOUNT_TYPE) {
    return '8';
  } else if (accountType === LALAMOVE_ACCOUNT_TYPE) {
    return '19';
  } else if (getUrlParam('bl')) {
    return getUrlParam('bl');
  } else {
    return '4';
  }
}

/**
 * 查询 app 是否开启通知
 * @returns Promise<Boolean>
 */
async function checkAppNotifyAuthStatus() {
  return new Promise((resolve, reject) => {
    window.pushNotification = val => {
      resolve(val);
    };
    callAppAction('pushNotificationAuth', {
      callback: 'pushNotification'
    });
    setTimeout(() => {
      reject('timeout');
    }, 500);
  });
}

/**
 * 调用 App Action
 * @param {String} actionName
 * @param {Object} options
 */
function callAppAction(actionName, options = {}) {
  const args = JSON.stringify({
    ...options,
    action: actionName
  });
  callApp(args);
}

function client_type() {
  if (isWxMiniProgram()) return 10;
  if (isAlipayMiniUa()) return 14;
  return isIOS() ? 2 : 1;
}

function urlHandle(url1, url2) {
  let hash = '';
  let isHashLast = url1.indexOf('#') > url1.indexOf('?');
  let searchObj = {};
  url2 = url2 ? url2.split('#')[0] : location.href.split('#')[0];
  if (isHashLast) {
    searchObj = getQueryArgs(url1.split('#')[0]) || {};
    hash = url1.split('#')[1];
  } else {
    searchObj = getQueryArgs(url1) || {};
  }
  let urlSearch = {};
  let paramsObj = {};
  let jumpUrl = '';
  let domain = url1.indexOf('?') > -1 ? url1.split('?')[0] : url1;
  let regHash = /#\/$/;
  domain = regHash.test(domain) ? domain.slice(0, domain.length - 2) : domain;
  // 获取当前url参数，与输入url参数组合
  urlSearch = url2.indexOf('?') > -1 ? getQueryArgs(url2) : {};
  if (urlSearch._token && !urlSearch.token) urlSearch.token = urlSearch._token;
  urlSearch.client_type = 'hlluser';
  paramsObj = { ...searchObj, ...urlSearch };
  jumpUrl =
    decodeURIComponent(domain + '?' + stringifyQuery(paramsObj)) +
    (isHashLast ? `#${hash}` : '');
  return jumpUrl;
}

function toMyCoupon() {
  let reg = /-stg|-pre|-gra/;
  let env = location.origin.match(reg) ? location.origin.match(reg)[0] : '';
  let args = getQueryArgs(location.href.split('#')[0]);
  let url = `https://pub-appweb${env}.huolala.cn`;
  args.channel_type = client_type();
  args.from_act = 'art_centre';
  if (
    !isHllApp() &&
    !isWxMiniProgram() &&
    !isAlipayMiniUa() &&
    !isJdMiniProgram()
  )
    return this.$hll.toast('请在货拉拉小程序或者app打开');
  if (isHllApp()) {
    location.href =
      urlHandle(url, location.href.split('#/')[0]) +
      `#/coupon/list?${stringifyQuery(args)}`;
  } else if (isJdMiniProgram()) {
    // 京东小程序
    /* eslint-disable  */
    jd.miniProgram.navigateTo({
      url: '/pages/user-center/lalaquan/index'
    });
  } else if (isWxMiniProgram()) {
    wx.miniProgram.navigateTo({
      url: isMoveMini() ? '/pages/user-center/lalaquan/index' : '/pages/lalaquan/exchange/index'
    });
  } else {
    my.navigateTo({
      url: '/pages/user-center/lalaquan/exchange/index'
    });
  }
}

/**
 * 跳转至小拉微信小程序webview页面
 * @param {*} token 客户端token
 * @param {*} url 目标 url
 */
function toXlWxaWeb (token, url = location.href) {
  const PREFIX = location.host.match(/-(\w)+/g);
  if (!PREFIX) {
    location.href = `https://user-h5.xiaolachuxing.com/index/startWeixin?token=${token}&webview=${encodeURIComponent(url)}`
  } else {
    location.href = `https://xl-user-index-v-stg.huolala.cn/startWeixin?token=${token}&webview=${encodeURIComponent(url)}`;
  }
}
/**
 * 是否需要城市id 以及经纬度
 * @param {*} isHideLoading
 * @param {*} isNeedLatAndLongAndCity
 * @returns
 */
export async function getLatAndLong (
  isHideLoading = false,
  isNeedLatAndLong = false
) {
  let locationObj = {};
  const cityId = getUrlParam('location_city_id')|| getUrlParam('city_id');

  console.log('fetch location from city id:', cityId);

  const isSkipWechat = getUrlParam('bl') === '8'; // 小拉暂不走微信定位
  locationObj.cityId = cityId && cityId != 0 ? cityId : null;
  if (isNeedLatAndLong) {
    const longitudeId = getUrlParam('longitude') || getUrlParam('lon');
    const latitudeId = getUrlParam('latitude') || getUrlParam('lat');
    locationObj.longitude = longitudeId;
    locationObj.latitude = latitudeId;
    if (!longitudeId || !latitudeId) {
      let locationByGet =
        (await getLocation(isHideLoading, isSkipWechat)) || {};
      locationObj = { ...locationObj, ...locationByGet };
    }
  } else {
    if (!locationObj.cityId) {
      locationObj = await getLocation(isHideLoading, isSkipWechat);
    }
  }
  return locationObj;
}

/**
 * 跳转至小拉微信小程序webview页面
 * 可以打开app 传入的路径不同
 * @param {*} url 目标 url
 */
 export function toXlWxaWebCommon(url, ref) {
  const PREFIX = window.location.host.match(/-(\w)+/g);
  let jumpurl = ''
  const _ref = ref ? `&_ref=${ref}` : ''
  const webview = url ? `webview=${encodeURIComponent(url)}` : ''
  if (!PREFIX) {
    jumpurl = `https://user-h5.xiaolachuxing.com/index/startUp?${webview}${_ref}`
  } else {
    jumpurl = `https://xl-user-index-v${PREFIX}.xiaolachuxing.com/startUp?${webview}${_ref}`
  }


  console.log('@enter minu  jump url', jumpurl);
  window.location.href = jumpurl;
}

/**
 * 下划线转驼峰
 * @param str
 * @returns
 */
 export function toCamel(str) {
  return str.replace(/([^_])(?:_+([^_]))/g, function(_$0, $1, $2) {
    return $1 + $2.toUpperCase();
  });
}

/**
 * 从链接上获取参数
 * @param key 传入的获取key  或者是 key的数组
 * @returns key 和对应val 的对象
 */
export function parseGetUrlParams(key) {
  let result = {};
  if (typeof key === 'string') {
    const val = getUrlParam(key) || getUrlParam(`_${key}`);
    const camelKey = toCamel(key);
    if (val) {
      result[`${camelKey}`] = val;
    }
  } else {
    key.forEach(_key => {
      result = { ...result, ...parseGetUrlParams(_key) };
    });
  }
  return result;
}

export function formateUrl(url) {
  const data = new Map();
  (url.match(/([^?=&#]+)(=([^&#]*))/g) || []).reduce((a, v) => {
    a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1);
    const key = v.slice(0, v.indexOf('=')),
      value = v.slice(v.indexOf('=') + 1);
    data.set(key, value);
    return a;
  }, {});
  return data;
}

/**
 * pick/unpick query 参数，withKeys 优先
 * withKeys，withoutKeys 都不传则返回当前所有 query
 * @param withKeys
 * @param withoutKeys
 * @param url 默认 location.href
 * @returns 返回 query object
 */
export function pickQueryParams(
  withKeys,
  withoutKeys,
  url = location.href,
) {
  const urlObj = parseURL(url);
  const queryObj = parseQuery(urlObj.search.slice(1));
  if (withKeys && Array.isArray(withKeys) && withKeys.length) {
    const newQuery = {};
    for (const key of withKeys) {
      if (queryObj[key]) {
        newQuery[key] = queryObj[key];
      }
    }
    return newQuery;
  }
  if (withoutKeys && Array.isArray(withoutKeys) && withoutKeys.length) {
    const newQuery = {};
    for (const key of Object.keys(queryObj)) {
      if (withoutKeys.indexOf(key) === -1) {
        newQuery[key] = queryObj[key];
      }
    }
    return newQuery;
  }
  return queryObj;
}

/**
 * 辅助创建分享链接，默认使用当前链接，默认清空 hash
 * @param withOriginQueryKeys 需要保留的 query 参数
 * @param insertQuery 插入 query 参数
 * @param url 默认 location.href
 * @param hash hash字符串 例如 #/my_awards，不传默认会清空当前 hash
 * @returns 返回 share url
 */
export function composeShareLink(
  withOriginalQueryKeys,
  insertQuery,
  hash,
  url = location.href,
) {
  let pickQuery = {};
  if (withOriginalQueryKeys && withOriginalQueryKeys.length) {
    pickQuery = pickQueryParams(withOriginalQueryKeys, [], url);
  }
  const mergedQueryObj = {
    ...pickQuery,
    ...insertQuery,
  };
  const urlObj = parseURL(url);
  if (hash) {
    urlObj.hash = hash;
  } else {
    urlObj.hash = '';
  }
  const queryString = stringifyQuery(mergedQueryObj);
  urlObj.search = queryString ? `?${queryString}` : '';
  return urlObj.toString();
}


export {
  overFlowHide,
  overFlowAuto,
  wxShare,
  setStorage,
  getStorage,
  parseQuery,
  parseURL,
  stringifyQuery,
  urlParamHandle,
  getQueryArgs,
  removeStorage,
  throttle,
  debounce,
  geetestInit,
  verifyPhone,
  getUrlParam,
  getAccessToken,
  formatTime,
  randomArr, //打乱数组
  isInIframe,
  scrollToEl,
  AES,
  getFingerPrint, //获取浏览器指纹,返回Promise
  isWxMiniProgram, //是否是微信小程序
  isLtlMiniProgram,
  isLtlApp,
  isXlMiniProgram,
  isMoveMini,
  isJdMiniProgram,
  toOrderPage,
  isWeixinBrowser, //是否是微信浏览器
  isAlipayMiniUa, //是否为支付宝小程序
  isBaiduBoxUa, // 是否为百度小程序
  isQuickAppUa, //是否为快应用
  isHllApp, //是否是huolalaApp
  getUserAppVer,
  isIOS,
  isMobile,
  isAlipayH5,
  type,
  isMoveAlpayMini,
  callApp, //调用app方法
  needWxAuth,
  needWxAuthPromise,
  isCompanyApp,
  getWxToken,
  isWxMiniProgramNew,
  getTDPrint, //获取同盾指纹
  getTDPass, //获取同盾passcode
  getLocation,
  getWxLocation,
  getAppLocation,
  getAmapLocation,
  calculateTimeDifference,
  sample,
  randomString,
  toMyCoupon,
  parseUserType,
  checkAppNotifyAuthStatus,
  callAppAction,
  genAccessTokenStr,
  parseBusinessLine,
  starPhone,
  isXlAppByClientType,
  toXlWxaWeb
};
